import type { ReactNode } from 'react';

interface ModulePageProps {
  id: string;
  title: string;
  className?: string;
  innerClassName?: string;
  bodyClassName?: string;
  meta?: ReactNode;
  actions?: ReactNode;
  flush?: boolean;
  children: ReactNode;
}

export function ModulePage({ id, title, className = '', innerClassName = '', bodyClassName = '', meta, actions, flush = false, children }: ModulePageProps) {
  return (
    <section className={`native-module module-page ${flush ? 'module-page--flush' : ''} ${className}`.trim()} aria-labelledby={id}>
      <div className={`module-page__inner ${innerClassName}`.trim()}>
        <header className="module-page__header">
          <div className="module-page__title-row">
            <h1 id={id}>{title}</h1>
            {meta}
          </div>
          {actions ? <div className="module-page__actions">{actions}</div> : null}
        </header>
        <div className={`module-page__body ${bodyClassName}`.trim()}>{children}</div>
      </div>
    </section>
  );
}
